/**
 * 既定値。ライブラリ既定（最下層）と、利用者が触るグローバル既定（第 2 層）を分けて持つ。
 */
import type { ViewerOptions, ViewerOptionsInput } from './options';

/** ライブラリ既定値。マージの最下層で、書き換えない。 */
export const LIBRARY_DEFAULTS: ViewerOptions = {
  source: '',
  assetBase: '',
  page: 1,
  direction: 'auto',
  mode: 'auto',
  engine: 'auto',
  delivery: 'auto',
  hardcover: false,
  zoomMax: 4,
  zoomStep: 1.5,
  hash: true,
  sound: true,
  soundFile: '',
  searchMinChars: 2,
  rangeChunkSize: 65536,
  userData: true,
  overlays: true,
  analytics: {
    // 自前収集（同一サーバへ送るだけ・第三者提供なし）は既定 ON
    collect: true,
    // 外部（GA4 / GTM）への送信は導入者が明示的に有効化したときだけ動く
    gtag: false,
    dataLayer: false,
  },
  share: {
    // 共有先は要件どおり既定なし（既定セットに依存しない・FR-LINK-05）
    targets: [],
    embedAllowlist: [],
    embedBase: '',
    viewBase: '',
    embedWidth: '100%',
    embedHeight: '600',
    qr: true,
  },
  ui: {
    toolbar: true,
    thumbnails: true,
    outline: true,
    search: true,
    share: true,
    marks: true,
    comments: true,
    help: true,
    speech: true,
    download: true,
    print: true,
  },
  preset: 'auto',
  theme: {},
  i18n: { locale: 'auto', strings: {} },
  on: {},
};

/**
 * グローバル既定値。公開 API の `defaults` として露出し、利用者がキー単位で書き換える
 * （例: defaults.hash = false で全ビューワのハッシュナビを無効化）。
 */
export const defaults: ViewerOptionsInput = {};
